//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import ErrorDisplay from '../../../../common/ErrorDisplay.vue';
import Checkbox from '../../../../common/svg/Checkbox.vue';
import Logo from '../../../../common/svg/Logo.vue';

import RegistrationStepAccountModal from '../components/modals/RegistrationStepAccountModal.vue';
import RegistrationStepTermsAndConditionsModal from '../components/modals/RegistrationStepTermsAndConditionsModal.vue';

export default {
  name: 'SauconyRegistration',
  components: {
    ErrorDisplay,
    Checkbox,
    Logo,
    RegistrationStepAccountModal,
    RegistrationStepTermsAndConditionsModal,
  },

  created() {
    this.pageTitle = 'Landing Page';
    this.description = 'Description';
    this.instructionsTitle = '2 Steps to Join';
  },

  data() {
    return {
      pageTitle: '',
      pageState: '',
      description: '',
      instructionsTitle: '',
      couponCode: 'testcohort',
      teamId: '1b3a146b-3607-4232-9098-b99e643c63f0',
      loading: false,
      steps: [
        {
          ref: 'terms-conditions',
          message: 'Accept terms and conditions',
          completed: null,
          component: 'registration-step-terms-and-conditions-modal',
        },
        {
          ref: 'account',
          message: 'Log in to link an existing PWR Lab account or create a new one',
          completed: null,
          component: 'registration-step-account-modal',
        },
      ],
      error: null,
    };
  },

  methods: {
    ...mapActions(['initialize', 'updatePayment']),

    async registerNow() {
      this.pageState = 'Registering to event...';
      this.loading = true;
      this.error = null;
      try {
        const { memberId } = this.loggedInMember;
        await this.$container.dao.addMemberToTeam(memberId, this.teamId);

        await this.initialize();

        if (this.isNewUser) {
          await this.$router.push({ name: 'setup' });
        } else {
          console.log(memberId);
          await this.updatePayment({
            member_id: memberId,
            coupon: this.couponCode,
          });
          await this.$router.push({ name: 'dashboard' });
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    handleError(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.loading = false;
    },

    launch(from) {
      this.$refs[from][0].launch();
    },
  },

  computed: {
    ...mapGetters(['user', 'loggedInMember']),
    areStepsCompleted() {
      return this.steps.some(step => step.completed === null);
    },

    isNewUser() {
      return this.steps.some(step => step.completed === 'new');
    },
  },
};
